import { isEmpty } from 'lodash'

export const onlyNumbers = (value) => {
  if (isEmpty(value)) return ''

  return value.replace(/\D/g, '')
}

export const onlyNumbersAndLetters = (value) => {
  if (isEmpty(value)) return ''

  return value.toUpperCase().replace(/[^0-9A-Z]/g, '')
}

export const onlyLetters = (value) => {
  if (isEmpty(value)) return ''

  return value.replace(/[^a-zA-Z0-9 ]/g, '')
}

export const removeSpaces = (value) => {
  if (isEmpty(value)) return ''

  return value.replace(/\s+/g, '')
}

export const hasLetters = (value) => {
  if (isEmpty(value)) return false

  return /[A-Z]/i.test(value)
}

const regex = {
  onlyNumbers,
  onlyNumbersAndLetters,
  onlyLetters,
  removeSpaces,
  hasLetters,
}

export default regex
